<template>
  <div>
    <WrapperDocRef :title="$t('message.refdocs')">
      <template
        v-if="purchase.status == 'approved'"
        #content
      >
        <BaseSectionDocRefLink
          :title="`${$t('sidebar.purchaseorder')} (${purchase.reference.purchase_orders.length})`"
          :links="POLinks"
          :createButtonText="$t('newdocuments.po')"
          :showCreateButton="getPRStatus(purchase, purchase.reference.purchase_orders.length ? purchase.reference.purchase_orders[0] : null, $t, mixin).status != 'completed'"
          @onCreate="handleClickCreatePO"
        />
      </template>
      <template
        v-else
        #content
      >
        -
      </template>
    </WrapperDocRef>

    <div
      id="createPOModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg-90-percent"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="col row no-padding no-margin">
              <div class="col-6 no-padding">
                <h5 class="modal-title">{{ $t('sidebar.purchaseorder') }}</h5>
              </div>
              <div class="col-6 no-padding text-right">
                <template>
                  <h5
                    v-if="!nextPoCode"
                    class="modal-title">
                    <i
                      class="fas fa-spinner spin"
                      style="font-size: 15px; position: relative; top: -1px; }"/>
                  </h5>
                  <h5
                    v-else
                    class="modal-title">
                    {{ nextPoCode }}
                  </h5>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <template>
              <FormPurchase
                v-if="showFormPO"
                :purchase="purchase"
                :validation="validateForm"
                @submit="onSubmitPurchase"/>
              <span v-else>
                {{ $t('message.loading') }}
              </span>
            </template>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closePOModal()">{{ $t('button.cancel') }}</button>
            <button
              :disabled="!showFormPO"
              type="button"
              class="btn btn-web"
              @click="validateForm++"
            >{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { toISODateString } from '@/helpers'
import _ from 'lodash'
import WrapperDocRef from '@/components/combine/WrapperDocRef.vue'
import BaseSectionDocRefLink from '@/components/base/BaseSectionDocRefLink.vue'
import FormPurchase from '../../../../custom/FormPurchase.vue'

export default {
  props: {
    purchase: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WrapperDocRef,
    BaseSectionDocRefLink,
    FormPurchase,
  },
  data () {
    return {
      showFormPO: false,
      validateForm: 0,
    }
  },
  computed: {
    ...mapGetters({
      loading: 'getLoading',
      nextPoCode: 'getNextPoCode',
      getPurchaseStatus: 'getPurchaseStatus',
      getDataSetPartnerUpdate: 'getDataSetPartnerUpdate',
      vendors: 'getVendors',
      getPRStatus: 'getPRStatus',
    }),
    POLinks() {
      return this.purchase.reference.purchase_orders.map((item) => {
        return {
          to: {
            name: 'PurchaseOrderEdit',
            query: {
              id: item.po_id,
              code: item.po_code,
            },
          },
          text: item.po_code,
          status: {
            text: this.getPurchaseStatus(item, this.$t, this.mixin).message,
            color: this.getColorFormStatus(this.getPurchaseStatus(item, this.$t, this.mixin).status),
            type: 'icon',
          },
          to_appid: 4,
          current_appid: 4,
        }
      })
    },
  },
  methods: {
    ...mapActions([
      'getNextPoCode',
    ]),
    async openPOModal () {
      // set status form
      this.showFormPO = true
      // show modal
      $('#createPOModal').modal('show')
      // get next code
      await this.getNextPoCode({ doc_type: 'po' })
      // finish bar loading
      this.showFinish(this.$Progress)
    },
    closePOModal () {
      // set status form
      this.showFormPO = false
      // show modal
      $('#createPOModal').modal('hide')
    },
    handleClickCreatePO() {
      this.openPOModal()
    },
    async onSubmitPurchase(form) {
      const isValid = (() => {
        if (form.pickedVendorId == null || form.pickedVendorId == '') {
          return false
        }
        return true
      })()

      if (!isValid) {
        return $('html, body, .modal').animate({ scrollTop: 0 }, 'slow')
      }

      let creditType = 'cash'
      let creditDays = 0

      if (form.selectedCredit == 'custom') {
        creditType = 'days'
        creditDays = form.inputCustomCreditDay
      } else if (form.selectedCredit.search('days.') >= 0) {
        let arr = form.selectedCredit.split('.')
        let days = arr[1]
        creditType = 'days'
        creditDays = days
      }

      let dataSet = {
        'doc_type': 'po',
        'status': 'padding',
        'note': form.note ? form.note : null,
        'created_at': form.created_at.toISOString(),
        'scheduled_at': form.scheduled_at.toISOString(),
        'vendor_id': form.pickedVendorId,
        'purchase_type': form.purchase_type,
        'credit': {
        	'type': creditType,
        	'days': parseInt(creditDays),
        },
        'orders': [],
        'ref_purchase_id': this.purchase.po_id,
      }

      const orders = form.orders

      for (let i in orders) {
        let order = orders[i]
        dataSet['orders'].push({
          'item': order.item,
        	'description': order.description,
        	'price': order.price,
        	'quantity': order.quantity,
        	'sku_id': order.sku_id,
          'discounts': order.discounts,
          'taxes': order.taxes,
        })
      }

      // update vendor
      let dataSetVendorUpdate = this.getDataSetPartnerUpdate('vendor', form.pickedVendorId, form.vendor, this.vendors)
      if (dataSetVendorUpdate !== null) {
        await this.$store.dispatch('updateVendor', dataSetVendorUpdate)
        await this.$store.dispatch('getVendors')
      }

      let res = await this.$store.dispatch('insertPurchase', dataSet)

      if (res.success) {
        const newPurchase = res.data.purchase
        await this.$store.dispatch('getPurchase', {
          po_id: this.purchase.po_id,
          doc_type: 'pr',
        })
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newPurchase.po_code }),
          color: 'success',
          icon: 'cloud',
        })
        this.closePOModal()
        this.showFinish(this.$Progress)
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }
    },
    getDataSetOrders (orders) {
      const data = _.cloneDeep(orders)
      const newData = []
      // remove key, data we don't need
      for (const i in data) {
        const item = data[i]
        if (item.sku_id) {
          newData.push({
            item: item.item,
            description: item.description,
            sku_id: item.sku_id,
            quantity: parseFloat(item.quantity) || 0,
            price: parseFloat(item.price) || 0,
            discounts: item.discounts.map((discount) => ({
              ...discount,
              type: 'general',
              value_amount: parseFloat(discount.value_amount),
            })),
            taxes: item.taxes.map((tax) => ({
              name: tax.tax_name,
              type: tax.type,
              amount: tax.amount,
              form_type: tax.form_type,
              group_name: tax.group_name,
              is_display_fee_result: tax.is_display_fee_result,
              is_for_sale: tax.is_for_sale,
              is_for_purchase: tax.is_for_purchase,
              fee: tax.fee ? tax.fee : null,
              tax_id: tax.tax_id,
            })),
          })
        }
      }
      return newData
    },
  },
  mounted: function () {
    // set popup modal
    this.setModal('#createPOModal')
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/purchases/pr/include/RefPO.vue